/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const GipAltReportDtoTypeEnum = {
    AUDIT_GIP_ALTERNATIVE_REPORT: "AUDIT_GIP_ALTERNATIVE_REPORT"
} as const;

export type GipAltReportDtoTypeEnumKey = (typeof GipAltReportDtoTypeEnum)[keyof typeof GipAltReportDtoTypeEnum];

export const StationsFiltersTypeEnum10 = {
    STATION_TYPE: "STATION_TYPE"
} as const;

export type StationsFiltersTypeEnum10Key = (typeof StationsFiltersTypeEnum10)[keyof typeof StationsFiltersTypeEnum10];

export const StationsFiltersValueEnum4 = {
    STANDALONE: "STANDALONE",
    HEADER: "HEADER",
    REPEATER: "REPEATER",
    AFFILIATE: "AFFILIATE"
} as const;

export type StationsFiltersValueEnum4Key = (typeof StationsFiltersValueEnum4)[keyof typeof StationsFiltersValueEnum4];

export const StationsFiltersTypeEnum11 = {
    STATION_GROUP: "STATION_GROUP"
} as const;

export type StationsFiltersTypeEnum11Key = (typeof StationsFiltersTypeEnum11)[keyof typeof StationsFiltersTypeEnum11];

export const StationsFiltersTypeEnum12 = {
    STATION_INDIVIDUAL: "STATION_INDIVIDUAL"
} as const;

export type StationsFiltersTypeEnum12Key = (typeof StationsFiltersTypeEnum12)[keyof typeof StationsFiltersTypeEnum12];

export const ExportStatusEnum2 = {
    SCHEDULED: "SCHEDULED",
    WAITING: "WAITING",
    WAITING_CHILDREN: "WAITING_CHILDREN",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED: "COMPLETED",
    FAILED: "FAILED",
    CANCELLED: "CANCELLED"
} as const;

export type ExportStatusEnum2Key = (typeof ExportStatusEnum2)[keyof typeof ExportStatusEnum2];

export const OptionsMediaTypeEnum2 = {
    AUDIO: "AUDIO",
    VIDEO: "VIDEO"
} as const;

export type OptionsMediaTypeEnum2Key = (typeof OptionsMediaTypeEnum2)[keyof typeof OptionsMediaTypeEnum2];

/**
 * GIP Alt Report
 * @description GIP Alternative report entity with GIP Alt-specific data structure
*/
export type GipAltReportDto = {
    /**
     * @description Unique identifier of the report
     * @type string, uuid
    */
    id: string;
    /**
     * @description Unique identifier of the client
     * @type string, uuid
    */
    clientId: string;
    /**
     * @description Report type must be AUDIT_GIP_ALTERNATIVE_REPORT
     * @type string
    */
    type: GipAltReportDtoTypeEnumKey;
    /**
     * @description Name of the report
     * @type string
    */
    name: string;
    /**
     * @description ID of the user who created the report
     * @type string | undefined, uuid
    */
    createdById?: string;
    /**
     * @description Whether the report is active
     * @type boolean
    */
    active: boolean;
    /**
     * @description ID of the associated AOD run
     * @type string | undefined, uuid
    */
    aodRunId?: string;
    /**
     * @description Timestamp when the report was created
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @description Timestamp when the report was last updated
     * @type string, date-time
    */
    updatedAt: string;
    /**
     * @description GIP Alt report data structure with config and export information
     * @type object
    */
    data: {
        /**
         * @description Data DTO for GIP report queries
         * @type object
        */
        config: {
            /**
             * @description The unique identifier of the client
             * @type string | undefined, uuid
            */
            clientId?: string;
            /**
             * @description Array of station IDs to query. Either this field or stationsFilters must be provided, but not both. Empty array will return all client stations.
             * @type array | undefined
            */
            stationsIds?: string[];
            /**
             * @description Array of station filters to apply. Either this field or stationsIds must be provided, but not both. Empty array will return all client stations.
             * @type array | undefined
            */
            stationsFilters?: ({
                /**
                 * @type string
                */
                type: StationsFiltersTypeEnum10Key;
                /**
                 * @type string
                */
                value: StationsFiltersValueEnum4Key;
            } | {
                /**
                 * @type string
                */
                type: StationsFiltersTypeEnum11Key;
                /**
                 * @type string, uuid
                */
                value: string;
            } | {
                /**
                 * @type string
                */
                type: StationsFiltersTypeEnum12Key;
                /**
                 * @type string, uuid
                */
                value: string;
            })[];
            /**
             * @description Start date/time for the report period (ISO 8601 with or without timezone)
             * @type string
            */
            from: string;
            /**
             * @description End date/time for the report period (ISO 8601 with or without timezone)
             * @type string
            */
            to: string;
            /**
             * @description Array of campaign names to filter by
             * @type array | undefined
            */
            campaigns?: string[];
            /**
             * @description Array of advertiser names to filter by
             * @type array | undefined
            */
            advertisers?: string[];
            /**
             * @description Array of version identifiers to filter by
             * @type array | undefined
            */
            versions?: string[];
            /**
             * @description Custom key-value pairs for additional filtering
             * @default [object Object]
             * @type object | undefined
            */
            customFields?: {
                [key: string]: string;
            };
            /**
             * @description Array of audio IDs to filter by
             * @type array | undefined
            */
            audioIds?: string[];
            /**
             * @description Array of custom IDs to filter by
             * @type array | undefined
            */
            customIds?: string[];
            /**
             * @description Array of order identifiers to filter by
             * @type array | undefined
            */
            orders?: string[];
            /**
             * @description Array of match IDs to exclude from the report
             * @type array | undefined
            */
            excludedMatches?: string[];
        };
        /**
         * @description Export-related data including status, options, and job information
         * @type object | undefined
        */
        export?: {
            /**
             * @description Current status of the export job
             * @type string | undefined
            */
            status?: ExportStatusEnum2Key;
            /**
             * @description Options for GIP evidence package configuration
             * @type object
            */
            options: {
                /**
                 * @description Exclude version in filenames and CSV/XLS files
                 * @deprecated
                 * @default false
                 * @type boolean | undefined
                */
                excludeVersion?: boolean;
                /**
                 * @description Include public link in filenames and CSV/XLS files
                 * @deprecated
                 * @default false
                 * @type boolean | undefined
                */
                publicLink?: boolean;
                /**
                 * @description Selected report definition id to use for the report export to XLS
                 * @type string | undefined
                */
                definitionId?: string;
                /**
                 * @description The type of media to package
                 * @default "AUDIO"
                 * @type string | undefined
                */
                mediaType?: OptionsMediaTypeEnum2Key;
                /**
                 * @description Seconds to include before the match start
                 * @minLength 0
                 * @default 0
                 * @type number | undefined
                */
                audioMatchIncludeBefore?: number;
                /**
                 * @description Seconds to include after the match end
                 * @minLength 0
                 * @default 0
                 * @type number | undefined
                */
                audioMatchIncludeAfter?: number;
                /**
                 * @description Path formatting options
                 * @type object | undefined
                */
                pathFormat?: {
                    /**
                     * @description Selected EvidencePackagePathFormat (stored in client config) id
                     * @type string | undefined
                    */
                    formatId?: string;
                    /**
                     * @description If the selected EvidencePackagePathFormat (stored in client config) includes the CUSTOM_TEXT token, use this value to replace it
                     * @type string | undefined
                    */
                    formatCustomText?: string;
                };
            };
            /**
             * @description ID of the export job when in progress or completed
             * @type string | undefined, uuid
            */
            jobId?: string;
            /**
             * @description URI where the exported file is stored when completed
             * @type string | undefined, uri
            */
            storageUri?: string;
        };
    };
};